import {ExamenDefinitionSummaryModel} from './examenDefinitionSummary.model';
import {FormDefinitionFormModel} from '../../../../form/definition/form/api/entity/formDefinitionForm.model';
import {IWithSummaryModel} from '../../../../common/permission/api/entity/iWithSummary.model';

export class ExamenDefinitionModel implements IWithSummaryModel<ExamenDefinitionSummaryModel> {
    formDefinition: FormDefinitionFormModel;
    summary: ExamenDefinitionSummaryModel;
}